import script from "./ordination.vue?vue&type=script&setup=true&lang=js"
export * from "./ordination.vue?vue&type=script&setup=true&lang=js"

import "./ordination.vue?vue&type=style&index=0&id=f58ea8fc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f58ea8fc"]])

export default __exports__